class PlotLine extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      scaleX,
      scaleY,
      getX,
      getY,
      color,
      stroke,
      shape,
      dot,
      dash
    } = this.props;

    let plotX = (d, i) => scaleX(getX(d, i));
    let plotY = (d) => scaleY(getY(d));

    let lineGenerator = d3.line()
      .x(plotX)
      .y(plotY)
      .defined((d) => !isNaN(getY(d)));

    if (shape === "curve") {
      lineGenerator.curve(d3.curveCardinal);
    }

    d3.select(this.refs.line)
      .datum(data)
      .attr("d", lineGenerator)
      .attr("stroke-width", stroke)
      .attr("stroke-dasharray", dash)
      .attr("stroke", color);

    if (dot) {
      let dots = d3.select(this.refs.dots)
        .selectAll("circle")
        .data(data);

      dots
        .exit()
        .remove();

      dots = dots
        .enter()
        .append("circle")
        .merge(dots)
        .attr("cx", plotX)
        .attr("cy", plotY)
        .attr("data-x", getX)
        .attr("data-y", getY);

      if (dot === "closed") {
        dots
          .attr("r", stroke + 2)
          .attr("fill", color);
      }

      if (dot === "open") {
        dots
          .attr("r", stroke + 3)
          .attr("stroke", color)
          .attr("stroke-width", stroke)
          .attr("fill", "white");
      }
    }
  }

  render() {
    let { opacity } = this.props;

    return (
      <g className="mc-plot-line" style={{ opacity }}>
        <path ref="line"/>
        <g ref="dots"/>
      </g>
    );
  }
}

PlotLine.defaultProps = {
  color: "#304561",
  stroke: 1,
  opacity: 1,
  shape: "straight", // "curve"
  dot: "closed", // "open", null
  dash: null // "4 4"
};

module.exports = PlotLine;